// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';
import massLaborRate from '../state/mass-labor-rates';
import {updateList} from '../../../shared/services/list-selections';

const updateListSelected = (state, action) =>
    massLaborRate.update(state, {
        $set: updateList(
            action.dealer,
            action.isSelected,
            'account',
            state
        )
    });

const resetSelectedDealers = state =>
    massLaborRate.update(state, {
        $set: []
    });

export default (state = getDefaultState().selectedDealers, action) => {

    const actionTypes = {
        [actions.RESET_TCSM_SELECTED_DEALERS]: resetSelectedDealers,
        [actions.UPDATE_TCSM_SELECTED_DEALER_ACCOUNTS]: updateListSelected
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/labor-rate-approval/reducers/dealers-selected.js